import {
  AreaChart,
  Area,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer
} from 'recharts';

const CustomTooltip = ({ active, payload, label }) => {
  if (active && payload && payload.length) {
    return (
      <div
        style={{
          background: '#2563EB',
          color: '#fff',
          padding: '4px 10px',
          borderRadius: '6px',
          fontSize: '13px',
          fontWeight: 500,
          display: 'flex',
          gap: '8px',
          alignItems: 'center'
        }}
      >
        <span>{payload[0]?.value}</span>
        <span style={{ opacity: 0.75, fontSize: '11px' }}>{payload[1]?.value}</span>
      </div>
    );
  }
  return null;
};

const CustomDot = (props) => {
  const { cx, cy, payload } = props;
  if (payload.name === 'Apr') {
    return (
      <g>
        <circle
          cx={cx}
          cy={cy}
          r={14}
          fill="none"
          stroke="#d1d5db"
          strokeWidth={2}
        />
        <circle cx={cx} cy={cy} r={9} fill="#0f4c40" />
      </g>
    );
  }
  return null;
};

export const AreaChartComponent = ({ type, userStat, orderStat }) => {
  if (type === 'monthlyUser') {
    return (
      <div className="overflow-x-auto w-full">
        <ResponsiveContainer width="100%" height={360}>
          <AreaChart data={userStat}>
            <defs>
              <linearGradient id="todayGradient" x1="0" y1="0" x2="0" y2="1">
                <stop offset="0%" stopColor="#0f4c40" stopOpacity={0.15} />
                <stop offset="100%" stopColor="#0f4c40" stopOpacity={0.02} />
              </linearGradient>
            </defs>

            <CartesianGrid
              horizontal={true}
              vertical={false}
              strokeDasharray=""
              stroke="#e5e7eb"
              strokeWidth={0.75}
            />

            <XAxis
              dataKey="name"
              axisLine={false}
              tickLine={false}
              tick={{ fontSize: 13, fill: '#9ca3af' }}
              dy={10}
            />

            <YAxis hide />

            <Tooltip content={<CustomTooltip />} cursor={false} />

            <Area
              type="monotone"
              dataKey="pv"
              stroke="#9ca3af"
              strokeWidth={1.5}
              strokeDasharray="6 4"
              fill="none"
              dot={false}
              activeDot={false}
              isAnimationActive={false}
            />

            <Area
              type="monotone"
              dataKey="uv"
              stroke="#0f4c40"
              strokeWidth={2.5}
              fill="url(#todayGradient)"
              dot={<CustomDot />}
              activeDot={{ r: 5, fill: '#0f4c40', stroke: '#fff', strokeWidth: 2 }}
              isAnimationActive={true}
            />
          </AreaChart>
        </ResponsiveContainer>
      </div>
    );
  }
  return (
    <div className="overflow-x-auto w-full">
      <ResponsiveContainer width="100%" height={360}>
        <AreaChart data={orderStat}>
          <defs>
            <linearGradient id="todayGradient" x1="0" y1="0" x2="0" y2="1">
              <stop offset="0%" stopColor="#0f4c40" stopOpacity={0.15} />
              <stop offset="100%" stopColor="#0f4c40" stopOpacity={0.02} />
            </linearGradient>
          </defs>

          <CartesianGrid
            horizontal={true}
            vertical={false}
            strokeDasharray=""
            stroke="#e5e7eb"
            strokeWidth={0.75}
          />

          <XAxis
            dataKey="name"
            axisLine={false}
            tickLine={false}
            tick={{ fontSize: 13, fill: '#9ca3af' }}
            dy={10}
          />

          <YAxis hide />

          <Tooltip content={<CustomTooltip />} cursor={false} />

          <Area
            type="monotone"
            dataKey="pv"
            stroke="#9ca3af"
            strokeWidth={1.5}
            strokeDasharray="6 4"
            fill="none"
            dot={false}
            activeDot={false}
            isAnimationActive={false}
          />

          <Area
            type="monotone"
            dataKey="uv"
            stroke="#0f4c40"
            strokeWidth={2.5}
            fill="url(#todayGradient)"
            dot={<CustomDot />}
            activeDot={{ r: 5, fill: '#0f4c40', stroke: '#fff', strokeWidth: 2 }}
            isAnimationActive={true}
          />
        </AreaChart>
      </ResponsiveContainer>
    </div>
  );
};
